export default __webpack_public_path__ + "static/media/Iloilo_logo.cdb0dbec.png";